export const state = () => ({
  loading: false,
  products: [],
  paymentMethod: 'permata_va',
});

export const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_PRODUCTS(state, payload) {
    state.products = payload;
  },
  SET_PAYMENT_METHOD(state, payload) {
    state.paymentMethod = payload;
  },
};

export const actions = {
  restoreInitialState({ commit }) {
    commit('SET_PAYMENT_METHOD', 'permata_va');
    commit('SET_PRODUCTS', []);
  },

  async attemptPay({ commit }, { orderUuid, cardTokenId }) {
    try {
      commit('SET_LOADING', true);
      let { data } = await this.$http.post('/api/orders/pay_card', {
        card_token: cardTokenId,
        order_uuid: orderUuid,
      });
      return data;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async submit(
    { commit, state, rootState, dispatch },
    { totalNetPrice, directActivation, duration, cardTokenId, expectFreeOrder },
  ) {
    try {
      commit('SET_LOADING', true);
      let actualExpectFreeOrder = false;
      if (expectFreeOrder === true) {
        actualExpectFreeOrder = true;
      }
      let { data } = await this.$http.post('/api/orders', {
        products: state.products.map((product) => {
          return {
            uuid: product.uuid,
            qty: product.qty,
            duration: duration,
            direct_activation: directActivation ? directActivation === 'true' : null,
          };
        }),
        payment_method: totalNetPrice > 0 ? state.paymentMethod : null,
        card_token: cardTokenId,
        promo_code: rootState.checkout.promo.valid ? rootState.checkout.promo.promoCode : null,
        expect_free_order: actualExpectFreeOrder,
      });
      return data;
    } catch (e) {
      console.log('ERROR SUBMIT PAY: ', e);
      if (e.response.status === 462) {
        await dispatch(
          'checkout/promo/checkPromo',
          {
            promoCode: rootState.checkout.promo.promoCode,
            productUuid: state.products[0].uuid,
            directActivation: directActivation ? directActivation === 'true' : null,
            qty: state.products[0].qty,
            duration: duration,
          },
          { root: true },
        );
      }
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async getIsOrderFree({ commit, state, rootState }, { directActivation, duration }) {
    try {
      commit('SET_LOADING', true);
      let { data } = await this.$http.post('/api/orders/is_order_free', {
        products: state.products.map((product) => {
          return {
            uuid: product.uuid,
            qty: product.qty,
            duration: duration,
            direct_activation: directActivation ? directActivation === 'true' : null,
          };
        }),
        promo_code: rootState.checkout.promo.valid ? rootState.checkout.promo.promoCode : null,
      });
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};
